// Placeholder rows shown inside a table body while data loads.
const TableSkeleton = ({
  rows = 8,
  columns,
}: {
  rows?: number;
  columns: number;
}) => (
  <tbody>
    {Array.from({ length: rows }).map((_, r) => (
      <tr key={r} className="border-b border-hcBorder">
        {Array.from({ length: columns }).map((_, c) => (
          <td key={c} className="py-4 px-4">
            <div
              className="h-3 rounded bg-gray-100 animate-pulse"
              style={{ width: `${55 + ((r * 7 + c * 13) % 40)}%` }}
            />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

export default TableSkeleton;
